// @ts-nocheck
/* eslint-disable */
export const arrowSideRightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12"><g fill="currentColor" clip-path="url(#a)"><path d="M10.46 0v4.22L8.68 6l1.78 1.78V12l-6-6zM3 12H1V0h2z"/></g><defs><clipPath id="a"><path fill="#fff" d="M12 12H0V0h12z"/></clipPath></defs></svg>`,
    name: 'arrow-side-right' as const
};